import membershipApiClient from '@/services/membership';

class Organisation {
  updateOrganisation = async (organisationId: string, userId: string, companyName: string) => {
    const response = await membershipApiClient.patch(
      `organisations/${organisationId}`,
      {
        orgId: organisationId,
        companyName,
        orgType: 'UNKNOW',
      },
      {
        headers: {
          organisationId,
        },
        params: {
          userId,
        },
      }
    );
    return response.data;
  };

  adminUpdateOrganisation = async (organisationId: string, userId: string, companyName: string) => {
    const response = await membershipApiClient.patch(
      `admin/organisations/${organisationId}`,
      {
        orgId: organisationId,
        companyName,
        orgType: 'UNKNOW',
      },
      {
        headers: {
          organisationId,
        },
        params: {
          userId,
        },
      }
    );
    return response.data;
  };
}

export const OrganisationInstance = new Organisation();
